var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTouched(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 4,
    fill: "#C5C8D4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2068 4.79303C12.3945 4.98056 12.5 5.23487 12.5 5.50003C12.5 5.76519 12.3945 6.0195 12.2068 6.20703L7.19985 11.207C7.01206 11.3945 6.7574 11.4998 6.49187 11.4998C6.22634 11.4998 5.97167 11.3945 5.78388 11.207L3.7811 9.20703C3.59869 9.01843 3.49776 8.76583 3.50004 8.50363C3.50232 8.24143 3.60763 7.99062 3.7933 7.80521C3.97897 7.6198 4.23013 7.51463 4.49269 7.51236C4.75525 7.51008 5.0082 7.61087 5.19707 7.79303L6.49187 9.08603L10.7908 4.79303C10.9786 4.60556 11.2333 4.50024 11.4988 4.50024C11.7644 4.50024 12.019 4.60556 12.2068 4.79303Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTouched);
export default __webpack_public_path__ + "static/media/touched.b295f0eb51b52cda08cd085f1d612345.svg";
export { ForwardRef as ReactComponent };